import React, { useState, useEffect } from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

import { ISidebarItem, ISidebarItemGroup } from "../Routes";
import IVenueSettings from "../../interfaces/IVenueSettings";
import { parseSidebarItems } from "./Sidebar";
import "../../scss/sidebar.scss";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";
import { useFlags } from "launchdarkly-react-client-sdk";

interface ISideBarListParentProps {
  item: ISidebarItemGroup;
  index: number;
  setMobileOpen: (active: boolean) => void;
  venueSettingsData: IVenueSettings | undefined;
  isEposNow: boolean;
  isSquare: boolean;
  isPay360: boolean;
  permissions: any;
  disabledRoutes: string[];
  selected: string;
  isLoading?: boolean;
  venueCountry?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      "&:hover .sidebar-icon": {
        opacity: 1,
      },
    },
  })
);

function SideBarListParent({
  index,
  item,
  setMobileOpen,
  venueSettingsData,
  isEposNow,
  isSquare,
  isPay360,
  disabledRoutes,
  selected,
  isLoading = true,
  venueCountry,
  permissions
}: ISideBarListParentProps) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const classes = useStyles();
  const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
  const { hasObAccess } = useFlags();
  const [venueHasAccessToOB, setVenueHasAccessToOB] = useState(false);
  const venueData = useSelector(
    (state: IReduxAppState) => state.venue[selectedVenueId]?.venueData
  );
  useEffect(() => {
    setVenueHasAccessToOB(hasObAccess && !isEposNow && !isPay360);
    //eslint-disable-next-line
  }, [selectedVenueId]);

  const childIsSelected = Object.values(item.items).some(
    (item: ISidebarItem) => item.key === selected
  );

  useEffect(() => {
    if (childIsSelected && !isLoading) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [childIsSelected, isLoading]);

  return (
    <div className={"navigation__menu-parent"}>
      <div className={`navigation__menu-parent__inner ${childIsSelected ? 'selected' : ''}`}>
        <ListItem
          data-component-name={item.key}
          button={false}
          className={classes.wrapper}
          onClick={() => {
            if (isLoading) {
              return;
            }
            setOpen(!open);
          }}
        >
          <ListItemIcon className="sidebar-icon">{isLoading ? <Skeleton variant="circle" width={20} height={20} animation="wave" /> : item.icon}</ListItemIcon>
          <ListItemText primary={isLoading ? <Skeleton variant="text" height={25} animation="wave" /> : t(item.text)} />
          <div className={`navigation__menu-parent__expand ${open ? "open" : ""}`}>
            <ExpandLess />
          </div>

        </ListItem>

        <Collapse in={open} timeout="auto" unmountOnExit>
          {parseSidebarItems(
            item.items,
            permissions,
            venueSettingsData,
            isEposNow,
            isSquare,
            isPay360,
            setMobileOpen,
            true,
            disabledRoutes,
            selected,
            venueHasAccessToOB,
            venueData?.onboarding_source,
            isLoading,
            undefined,
            venueCountry
          )}
        </Collapse>
      </div>
    </div>
  );
}

export default SideBarListParent;
